<div class="container-fluid mt-3">
	<div class="d-flex justify-content-between align-items-center mb-3">
		<h4 class="mb-0">{{'multi_tariff.global_title' | translate}}</h4>
		<button
			*ngIf="hasWriteAccess"
			type="button"
			class="btn btn-primary"
			[routerLink]="['/admin-panel/multi-tariff/profiles/edit', 0]"
		>
			{{'multi_tariff.profile.add_profile' | translate}}
		</button>
	</div>

	<table class="table table-striped">
		<thead>
			<tr>
				<th>{{'g.name' | translate}}</th>
				<th>{{'multi_tariff.profile.currency' | translate}}</th>
				<th>{{'site.sites' | translate}}</th>
				<th>{{'g.actions' | translate}}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let profile of profiles">
				<td>{{profile.name}}</td>
				<td>{{multiTariffService.getCurrencyName(profile.currency)}}</td>
				<td>
					<button
						*ngIf="profile.sites_count"
						type="button"
						class="btn btn-sm btn-primary"
						(click)="showProfileSites(profile)"
					>
						{{'multi_tariff.profile.display_sites' | translate}} ({{profile.sites_count}})
					</button>
					<strong *ngIf="!profile.sites_count">-</strong>
				</td>
				<td>
					<a class="btn btn-sm btn-link" [routerLink]="['/admin-panel/multi-tariff/profiles/edit', profile.id]">
						{{'g.edit' | translate}}
					</a>
					<button
						*ngIf="hasWriteAccess && !profile.is_special"
						type="button"
						class="btn btn-sm btn-link text-danger"
						(click)="confirmDelete(profile)"
					>
						{{'g.delete' | translate}}
					</button>
				</td>
			</tr>
			<tr *ngIf="!profiles.length">
				<td colspan="4" class="text-center">{{'g.no_data_available' | translate}}</td>
			</tr>
		</tbody>
	</table>
</div>

<app-modal #deleteConfirmModal title="{{'g.confirm_action' | translate}}" size="md">
	<p>{{'multi_tariff.profile.delete' | translate: {profile_name: profileToDelete?.name} }}</p>
	<p *ngIf="profileToDelete?.sites_count">
		<button type="button" class="btn btn-secondary" (click)="deleteConfirmModal.hide(); showReplaceOptions()">
			{{'g.delete_replace' | translate}}
		</button>
	</p>
</app-modal>

<app-modal #replaceProfileModal title="{{'g.select_another_profile' | translate}}" size="md">
	<ng-select
		[items]="profilesToReplaceWith"
		bindLabel="name"
		bindValue="id"
		placeholder="{{'multi_tariff.profile.Select_profile_to_replace' | translate}}"
		name="newProfileId"
		[(ngModel)]="newProfileId"
	></ng-select>
</app-modal>

<app-modal #profileSitesModal title="{{'multi_tariff.profile.profile_related_sites' | translate}}" size="md" [hasConfirmButton]="false">
	<table class="table table-striped mb-0">
		<thead>
			<tr>
				<th>{{'g.name' | translate}}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let site of profileSites">
				<td><a [routerLink]="['/', site.customer_id, site.id]" (click)="profileSitesModal.hide()">{{site.name}}</a></td>
			</tr>
		</tbody>
	</table>
</app-modal>
